import {Component, Input, OnInit} from '@angular/core';
import * as _ from 'lodash'
import { ROSE_CHART_COLORS } from '../../../helpers/chart-helper';

@Component({
  selector: 'app-pie-rose-chart',
  templateUrl: './pie-rose-chart.component.html',
  styleUrls: ['./pie-rose-chart.component.less']
})
export class PieRoseChartComponent implements OnInit {

  @Input() title = '';
  @Input() dataSource: any[];
  @Input() argumentField: string;
  @Input() valueField: string;
  @Input() isRose: boolean;
  @Input() showLegend: boolean = false;
  dataSourceTemp: any[];
  
  chartOption: any;
  
  initOpts = {
    renderer: 'canvas',
    width: 550,
    height: 400
  };
  borderRadius = 10;
  radius = ['15%', '90%'];
  center = ['50%', '50%'];

  constructor() {
  }

  ngOnInit() {
    this.dataSourceTemp = JSON.parse(JSON.stringify(this.dataSource));
    this.dataSourceTemp = _.sortBy(this.dataSourceTemp, [this.argumentField, this.valueField], ['asc', 'desc']);

    let dataSeries = [];
    if (this.dataSourceTemp && this.dataSourceTemp.length) {
      this.dataSourceTemp.forEach(item => {
        dataSeries.push({
          value: item[this.valueField],
          name: item[this.argumentField],
          label: {
            color: '#000',
          },
        });
      });

      var numZero = _.filter(dataSeries, function(o) { if (o.value === 0) return o }).length;
      if (numZero < dataSeries.length) {
        dataSeries = _.filter(dataSeries, function(o) {
          return o.value !== 0;
      });
      }
    }

    let insideSeries = JSON.parse(JSON.stringify(dataSeries));
    if (insideSeries.length > 0) {
      let colorIndex = 0;
      for (let i = 0; i < insideSeries.length; i++) {
        if (colorIndex === 0) {
          insideSeries[i].label.color = '#fff';  
        }        
        colorIndex++;
        if (colorIndex === ROSE_CHART_COLORS.length) {
          colorIndex = 0;
        }
      }
    }
    
    let roseType = this.isRose ? 'radius' : '';

    this.chartOption = {
      color: ROSE_CHART_COLORS,
      tooltip: {
        trigger: 'item',
        borderRadius: 0,
        shadowColor: null,
      },
      legend: {
        show: this.showLegend,
        orient: 'vertical',
        top: '5%',
        right: '0',
        formatter: function (name) {
          if (name && name.length > 23) {
            name = name.substring(0, 20) + '...';
          };
          return name;
        }
      },
      series: [
        {
          name: this.title,
          type: 'pie',
          radius: this.radius,
          center: this.center,
          roseType: roseType,
          itemStyle: {
            borderRadius: this.borderRadius
          },
          label: {
            position: 'outside',
            formatter: '{b}',
            color: '#000',
            backgroundColor: 'transparent'
          },
          data: dataSeries
        },
        {
          name: this.title,
          type: 'pie',
          radius: this.radius,
          center: this.center,
          roseType: roseType,
          itemStyle: {
            borderRadius: this.borderRadius
          },
          label: {
            position: 'inside',
            formatter: function (d) {
              const fixedValue = d.value.toFixed(1);
              return fixedValue + '%';
            }
          },
          data: insideSeries
        }
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/chart/pie-rose-chart/pie-rose-chart.component.ts